/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Figma({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="212 340 600 600" {...props}><path fill="#24CB71" d="M312 840c0-55.228 44.772-100 100-100h100v100c0 55.228-44.772 100-100 100s-100-44.772-100-100" /><path fill="#FF7237" d="M512 340v200h100c55.228 0 100-44.772 100-100s-44.772-100-100-100z" /><circle cx={611.167} cy={640} r={100} fill="#00B6FF" /><path fill="#FF3737" d="M312 440c0 55.228 44.772 100 100 100h100V340H412c-55.228 0-100 44.772-100 100" /><path fill="#874FFF" d="M312 640c0 55.228 44.772 100 100 100h100V540H412c-55.228 0-100 44.772-100 100" /></svg>;
}
;